import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  /** Monospace (phone numbers / IDs). */
  mono?: boolean;
}

/** Text input. Pair with <Field> for label/hint/error, or use standalone. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, mono, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cx('tc-input', invalid && 'tc-input--invalid', mono && 'tc-input--mono', className)}
      {...rest}
    />
  );
});
